enum AgreementStatuses {
  active = 'active',
  finishing = 'finishing',
  notStarted = 'not-started-yet',
  freshlyFinished = 'freshly-finished',
  inactive = 'inactive',
}

export default AgreementStatuses;
